/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';
require('mq-respond');

var tls  = require('./tls');
var page = require('./page');
var util = require('./util');
var rating = require('./rating');
var emailSignup = require('./email-signup');
var gtm = require('./gtm');
var tooltip  = require('./tooltip');
var validator = require('./validator');
var countries = require('./countries');
var slickCarousel  = require('./slickCarousel');
var productToggler = require('./pages/product/productToggler');
var consentTracking = require('./consentTracking');
var productStickyElements = require('./pages/product/productStickyElements');
var imageHelpers = require('./imageHelpers');
var iosOnlyFixes = require('./iosOnlyFixes');

// eslint-disable-next-line
__webpack_public_path__ = window.publicPath;

// refapp SVGs should be imported first as they are pre-pended to <body>,
// so brands-specific SVGs would end appearing in the <body> in the first place.
// This is required as browser uses the very first occurrence to resolve SVG href="#..."
import(/* webpackChunkName: 'refapp' */ './svg/refapp').then(() => {
    // brand specific SVGs
    import(/* webpackChunkName: '[request]' */ `./svg/brands/${window.currentSiteID}`);
});

if (window.modulesSystem.isDevelopmentModeOn) {
    // refapp global site styles
    import(/* webpackChunkName: 'aob_style' */ '@app_aob_core/cartridge/sass/main.scss');

    // brand-specific global site styles
    const importBrandStyles = {
        bubbablade_us() {
            import(/* webpackChunkName: 'bubbablade_us-include-scss' */ '@app_bubbablade/cartridge/sass/main.scss');
        },
        caldwell_us() {
            import(/* webpackChunkName: 'caldwell_us-include-scss' */ '@app_caldwell/cartridge/sass/main.scss');
        },
        frankford_us() {
            import(/* webpackChunkName: 'frankford_us-include-scss' */'@app_frankford/cartridge/sass/main.scss');
        },
        wheeler_us() {
            import(/* webpackChunkName: 'wheeler_us-include-scss' */'@app_wheeler/cartridge/sass/main.scss');
        },
        bog_us() {
            import(/* webpackChunkName: 'bog_us-include-scss' */'@app_bog/cartridge/sass/main.scss');
        },
        smithwesson_us() {
            import(/* webpackChunkName: 'smithwesson_us-include-scss' */'@app_smithwesson/cartridge/sass/main.scss');
        },
        thompsoncenter_us() {
            import(/* webpackChunkName: 'thompsoncenter_us-include-scss' */'@app_thompsoncenter/cartridge/sass/main.scss');
        },
        hooyman_us() {
            import(/* webpackChunkName: 'hooyman_us-include-scss' */'@app_hooyman/cartridge/sass/main.scss');
        },
        lockdown_us() {
            import(/* webpackChunkName: 'lockdown_us-include-scss' */'@app_lockdown/cartridge/sass/main.scss');
        },
        meat_us() {
            import(/* webpackChunkName: 'meat_us-include-scss' */'@app_meat/cartridge/sass/main.scss');
        },
        meat_ca() {
            import(/* webpackChunkName: 'meat_ca-include-scss' */'@app_meat/cartridge/sass/main_ca.scss');
        },
        crimsontrace_us() {
            import(/* webpackChunkName: 'crimsontrace_us-include-scss' */'@app_crimsontrace/cartridge/sass/main.scss');
        },
        ust_us() {
            import(/* webpackChunkName: 'ust_us-include-scss' */'@app_ust/cartridge/sass/main.scss');
        },
        tipton_us() {
            import(/* webpackChunkName: 'tipton_us-include-scss' */'@app_tipton/cartridge/sass/main.scss');
        },
        schrade_us() {
            import(/* webpackChunkName: 'schrade_us-include-scss' */'@app_schrade/cartridge/sass/main.scss');
        },
        oldtimer_us() {
            import(/* webpackChunkName: 'oldtimer_us-include-scss' */'@app_oldtimer/cartridge/sass/main.scss');
        }
    }[window.currentSiteID];
    importBrandStyles();
}

// if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
    var s = document.createElement('script');
    s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
    s.setAttribute('type', 'text/javascript');
    document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
consentTracking.init();
require('./captcha')();

function initializeEvents() {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;

            if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            var text        = $.trim($(this).val());
            var charsLimit  = $(this).data('character-limit');
            var charsUsed   = text.length;
            var charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).next('div.char-count').find('.char-remain-count').html(charsRemain);
        });

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    $('.toggle').next('.toggle-content').hide();
    $('.toggle').click(function () {
        $(this).toggleClass('expanded').next('.toggle-content').toggle();
    });

    // main menu toggle
    $('.menu-toggle').on('click', function () {
        $('#wrapper').toggleClass('menu-active');
    });
    $('.menu-category li .menu-item-toggle').on('click', function (e) {
        e.preventDefault();
        var $parentLi = $(e.target).closest('li');
        $parentLi.siblings('li').removeClass('active').find('.menu-item-toggle').removeClass('fa-chevron-up active').addClass('fa-chevron-right');
        $parentLi.toggleClass('active');
        $(e.target).toggleClass('fa-chevron-right fa-chevron-up active');
    });
    $('.user-account').on('click', function (e) {
        e.preventDefault();
        $(this).parent('.user-info').toggleClass('active');
    });

    require('./checkout-generic');

    // Hover on svg social icons
    $('.social-link').each(function() {
        if ($(this).attr('data-hover')) {
            var currLink = $(this).find('.social-icon').attr('src');
            var hoverLink = $(this).attr('data-hover');
            $(this).hover(
                function() {
                    $(this).find('.social-icon').attr('src', hoverLink);
                }, function() {
                    $(this).find('.social-icon').attr('src', currLink);
                }
            );
        }
    });

    // Verify if the search input is empty and disable/enable the search button
    var $searchButton = $('#searchButton');

    $(document).on('change input', '#q', function(e) {
        if ($(this).val().length > 0 && /\S/.test($(this).val())) {
            $searchButton.removeAttr('disabled');
            // Add Info to GTM
            var dataGtm = $searchButton.attr('data-gtm');
            var parsedJson;
            try {
                parsedJson = JSON.parse(dataGtm);
            } catch (error) {
                parsedJson = JSON.parse(dataGtm.replace(/'/gi, '"').replace(/\\"/, '\''));
            }
            parsedJson.action = $(this).val();
            $searchButton.attr('data-gtm', JSON.stringify(parsedJson));
        } else {
            $searchButton.attr('disabled', 'disabled');
        }
    });

    // handles active menu entries for extendable nav
    var $navMenu = $('.c-extendable-menu__nav-list');

    $navMenu.find('.selected-item').removeClass('selected-item');

    $navMenu.find('a').each(function(index, element) {
        if (element.href === location.href) {
            $(element).addClass('selected-item');
        }
    });
}
/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }

    // load js specific styles
    util.limitCharacters();
}

var pages = {
    account: () => import(/* webpackChunkName: "account" */ './pages/account'),
    cart: () => import(/* webpackChunkName: "cart-sg" */ './pages/cart'),
    checkout: () => import(/* webpackChunkName: "checkout-sg" */ './pages/checkout'),
    compare: () => import(/* webpackChunkName: "compare" */ './pages/compare'),
    product: () => import(/* webpackChunkName: "product" */ './pages/product'),
    registry: () => import(/* webpackChunkName: "registry" */ './pages/registry'),
    search: () => import(/* webpackChunkName: "search" */ './pages/search'),
    storefront: () => import(/* webpackChunkName: "storefront" */ './pages/storefront'),
    wishlist: () => import(/* webpackChunkName: "wishlist" */ './pages/wishlist'),
    storelocator: () => import(/* webpackChunkName: "storelocator" */ '../../../int_storelocator/cartridge/js/pages/storelocator'),
    formstack: () => import(/* webpackChunkName: "formstack" */ './pages/formstack'),
    error: () => import(/* webpackChunkName: "error" */ './pages/error'),
    styleguide: () => import(/* webpackChunkName: "styleguide" */ './pages/styleguide'),
    giftcert: () => import(/* webpackChunkName: "giftCert" */ './pages/giftCert'),
    securewall: () => import(/* webpackChunkName: "securewall" */ './pages/securewall')
};

var app = {
    init: function () {
        window.mqR = window.mqR || new mqRes([
            {
                label: 'phone',
                from: 0,
                to: 767
            },
            {
                label: 'tablet',
                from: 768,
                to: 1023
            },
            {
                label: 'desktop',
                from: 1024,
                to: 1679
            },
            {
                label: 'desktopLarge',
                from: 1680
            }
        ]);

        window.mqR.remove = function(callback) {
            const callbackIndex = this.callbacks.indexOf(callback);

            this.callbacks.splice(callbackIndex, 1);
        };

        import(/* webpackChunkName: 'modules_system' */'../../../int_acf_core/cartridge/js/modules_system').then((assetStudio) => {
            assetStudio.default.init();

            if (document.cookie.length === 0) {
                $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
            }
            initializeDom();
            initializeEvents();

            // init specific global components
            emailSignup.init();
            countries.init();
            tooltip.init();
            slickCarousel.init();
            import(/* webpackChunkName: "product-quantity" */ './pages/product/productQuantity').then((productQuantity) => {
                productQuantity.default.init();
            });
            productStickyElements.init();
            productToggler.init();
            validator.init();
            rating.init();
            gtm.init();

            // execute page specific initializations
            $.extend(page, window.pageContext);
            var ns = page.ns;

            if (ns && pages[ns]) {
                pages[ns]().then((page) => {
                    if (page.init) {
                        page.init();
                    } else if (page.default.init) {
                        page.default.init();
                    }
                });
            }

            // Check TLS status if indicated by site preference
            if (SitePreferences.CHECK_TLS === true) {
                tls.getUserAgent();
            }

            const spinnerLoader = document.querySelector('.loader-overlay-container');

            if (spinnerLoader) {
                spinnerLoader.classList.remove('loader-overlay-container');
            }
        });
    }
};

// general extension functions
(function () {
    String.format = function () {
        var s = arguments[0];
        var i, len = arguments.length - 1;
        for (i = 0; i < len; i++) {
            var reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    };
})();

// initialize app
$(document).ready(function () {
    iosOnlyFixes.default.applyNoInputScrollFix();
    app.init();
    import(/* webpackChunkName: '[request]' */ `./brands/${window.currentSiteID}/include.js`).then((brand) => {
        brand.init();
    });
});

imageHelpers.default.init();
